import { Stack, styled, Typography } from '@mui/material';
import React from 'react';

import { colors } from '../theme/theme';

const LoaderWrapper = styled(Stack)(() => ({
    position: 'fixed',
    inset: 0,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    gap: 24,
    zIndex: 1350,
    backgroundColor: 'rgba(0, 0, 0, 0.5)',

    /* Loader container */
    '.loader': {
        animation: 'rotate 1s infinite',
        height: '50px',
        width: '50px',
        position: 'relative',
    },

    /* Balls */
    '.loader::before, .loader::after': {
        borderRadius: '50%',
        content: '""',
        display: 'block',
        height: '20px',
        width: '20px',
    },

    '.loader::before': {
        animation: 'ball1 1s infinite',
        backgroundColor: '#fff',
        boxShadow: `30px 0 0 ${colors.primaryLight[100]}`,
        marginBottom: '10px',
    },

    '.loader::after': {
        animation: 'ball2 1s infinite',
        backgroundColor: colors.primaryLight[100],
        boxShadow: '30px 0 0 #fff',
    },

    /* Animations */
    '@keyframes rotate': {
        '0%': {
            transform: 'rotate(0deg) scale(0.8)',
        },
        '50%': {
            transform: 'rotate(360deg) scale(1.2)',
        },
        '100%': {
            transform: 'rotate(720deg) scale(0.8)',
        },
    },

    '@keyframes ball1': {
        '0%': {
            boxShadow: `30px 0 0 ${colors.primaryLight[100]}`,
        },
        '50%': {
            boxShadow: `0 0 0 ${colors.primaryLight[100]}`,
            marginBottom: '0',
            transform: 'translate(15px, 15px)',
        },
        '100%': {
            boxShadow: `30px 0 0 ${colors.primaryLight[100]}`,
            marginBottom: '10px',
        },
    },

    '@keyframes ball2': {
        '0%': {
            boxShadow: '30px 0 0 #fff',
        },
        '50%': {
            boxShadow: '0 0 0 #fff',
            marginTop: '-20px',
            transform: 'translate(15px, 15px)',
        },
        '100%': {
            boxShadow: '30px 0 0 #fff',
            marginTop: '0',
        },
    },
}));

interface LoaderProps {
    /** Optional message shown below the spinner, e.g. for a full-screen loading state. */
    message?: React.ReactNode;
}

export const Loader: React.FC<LoaderProps> = ({ message }) => {
    return (
        <LoaderWrapper>
            {/* Optional MUI loader */}
            {/* <CircularProgress size={40} thickness={4} sx={{ color: colors.primaryLight[100] }} /> */}
            <span className="loader" />
            {message && (
                <Typography variant="h6" color={colors.fullWhite}>
                    {message}
                </Typography>
            )}
        </LoaderWrapper>
    );
};
